
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.633 1.029a1.403 1.403 0 011.984-.043l2.895 2.775-6.987 7.29A4.58 4.58 0 117.5 9.11l1.95-2.034-1.705-1.633a1.403 1.403 0 111.941-2.026l1.705 1.634 1.155-1.206-.87-.833a1.403 1.403 0 01-.042-1.983zm-4.91 10.92a1.775 1.775 0 10-2.457 2.563 1.775 1.775 0 002.456-2.564z","fill":"#5935DD"}})])
          )
        }
      }
    